import React from 'react';
import styled from 'styled-components';
import { colors, remCalc, layout } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';
import UserAvatarComponent from '@prisjakt/ui-user-avatar';
import AccountIconBase from 'mdi-react/AccountIcon';
import AlertsIconBase from 'mdi-react/BellOutlineIcon';
import ListsIconBase from 'mdi-react/HeartOutlineIcon';
import { Hideable } from '@regular_ui/lib/components/hideable';
import { slowRevealHideableVariant } from '@prisjakt/customization_prisjakt/variants/hideable';
import { MenuItem } from '../../views/user/styles';

const baseMargin = 8;

export const UserMenu = styled(Hideable).attrs({
  variant: slowRevealHideableVariant,
  renderWhenHidden: true,
})`
  margin-bottom: ${layout.spacing.xSmall};
`;

export const UserMenuList = styled.div`
  border-bottom: 1px solid ${props => props.theme.lines.primary};
  display: flex;
  flex: 1 0 calc(100% - ${remCalc(baseMargin * 2)});
  flex-direction: column;
  padding-bottom: ${remCalc(baseMargin * 2)};
  margin-top: ${layout.spacing.small};
`;

export const UserMenuItem = styled(MenuItem).attrs({ sidebar: true })``;

const iconColorStyle = `
  background: ${colors.semiWhite};
  color: ${colors.lightBlue3};
`;

export const IconWrapper = styled.div`
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  ${iconColorStyle};
`;

export const LoginButtonWrapper = styled.div`
  margin-left: ${layout.spacing.xSmall};
  margin-right: ${layout.spacing.xSmall};
`;

export const LoginButton = styled(Button)`
  margin-bottom: ${layout.spacing.xSmall};
  width: 100%;
`;

export const AccountIcon = () => (
  <IconWrapper>
    <AccountIconBase />
  </IconWrapper>
);

export const AlertsIcon = () => (
  <IconWrapper>
    <AlertsIconBase size={28} />
  </IconWrapper>
);

export const ListsIcon = () => (
  <IconWrapper>
    <ListsIconBase size={28} />
  </IconWrapper>
);

export const UserAvatar = styled(UserAvatarComponent)`
  ${iconColorStyle};

  &:hover {
    ${iconColorStyle};
  }
`;
